import { ChevronDownIcon, ExternalIcon } from "../icons";

export function Header() {
  return (
    <header className="topbar">
      <div className="topbar-brand">
        <a className="wordmark" href={import.meta.env.BASE_URL} aria-label="SchemaRelay home">SchemaRelay</a>
        <span className="topbar-divider" />
        <button className="workspace-switcher" type="button">
          Demo workspace <ChevronDownIcon width={15} height={15} />
        </button>
      </div>
      <nav className="topbar-actions" aria-label="Product navigation">
        <a href="https://github.com/14188769700lbk-dev/schemarelay#readme" target="_blank" rel="noreferrer">
          Documentation <ExternalIcon width={14} height={14} />
        </a>
        <a className="calle-mark" href="https://www.heycall-e.com/" target="_blank" rel="noreferrer">CALL-E</a>
        <button className="avatar-button" type="button" aria-label="Open user menu">
          <span>AK</span><ChevronDownIcon width={14} height={14} />
        </button>
      </nav>
    </header>
  );
}
